import { render, staticRenderFns } from "./training-overview.vue?vue&type=template&id=1f30464f"
import script from "./training-overview.vue?vue&type=script&lang=js"
export * from "./training-overview.vue?vue&type=script&lang=js"
import style0 from "./training-overview.vue?vue&type=style&index=0&id=1f30464f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports